export enum AcAction {
    Mode = 'mode',
    Airflow = 'airflow',
    Temperature = 'temperature'
}

export enum AcMode {
    Off = 'off',
    Auto = 'auto',
    Cool = 'cool',
    Heat = 'heat',
    FanOnly = 'fanonly',
    Dry = 'dry'
}

export enum AcAirflow {
    Weak = 'weak',
    Medium = 'medium',
    Strong = 'strong',
    Auto = 'auto'
}

export const ModeMap: { [index: number]: AcMode } = {
    0: AcMode.Off,
    1: AcMode.Auto,
    3: AcMode.Cool,
    4: AcMode.Heat,
    7: AcMode.FanOnly,
    8: AcMode.Dry
};

export const AirflowMap: { [index: number]: AcAirflow } = {
    1: AcAirflow.Weak,
    2: AcAirflow.Medium,
    3: AcAirflow.Strong,
    4: AcAirflow.Auto
};
